import React from 'react';
import Link, {LinkProps} from '../link/Link';
import {Button as EuiButton, ButtonProps as EuiButtonProps} from '@epic-ui/components';
import {ButtonSkeleton} from '..';
import {makeStyles, Theme} from '@material-ui/core';

// icon button in mobile screens if startIcon / endIcon given
const useStyles = makeStyles<Theme, {showIconOnMobile: boolean}>(
    theme => ({
        root: {
            [theme.breakpoints.down('sm')]: {
                padding: 0
            }
        },
        endIcon: {
            [theme.breakpoints.down('sm')]: {
                marginLeft: 0,
                marginRight: 0
            }
        },
        startIcon: {
            [theme.breakpoints.down('sm')]: {
                marginLeft: 0,
                marginRight: 0
            }
        },
        label: {
            [theme.breakpoints.down('sm')]: {
                '& span:not(.MuiButton-startIcon):not(MuiButton-endIcon)': {
                    display: 'none'
                }
            }
        }
    }),
    {name: 'EuiButton'}
);

export type ButtonProps = EuiButtonProps &
    Partial<Omit<LinkProps, keyof EuiButtonProps>> & {
        isLoading?: boolean;
        showIconOnMobile?: boolean;
    };

const Button = React.forwardRef<any, ButtonProps>(
    ({isLoading, children, to, isExternalUrl, showIconOnMobile, ...rest}, ref) => {
        const showIconOnly = !!(showIconOnMobile && (rest.startIcon || rest.endIcon));
        const classes = useStyles({showIconOnMobile: showIconOnly});

        if (isLoading) {
            return (
                <ButtonSkeleton width="inherit" height="inherit">
                    <EuiButton {...rest} classes={showIconOnly && classes}>
                        {children}
                    </EuiButton>
                </ButtonSkeleton>
            );
        }

        let conditionalProps;

        if (!to) {
            conditionalProps = {ref};
        } else {
            conditionalProps = {
                to,
                isExternalUrl,
                component: Link,
                forwardRef: ref,
                underline: 'none'
            };
        }

        return (
            <EuiButton {...rest} {...conditionalProps} classes={showIconOnly && classes}>
                {children}
            </EuiButton>
        );
    }
);

export default Button;
